import { RequestDataValue } from '../../../../context/RequestDataContext';
import { fetchControlApiMethodOptions } from '../../../../api/utils/fetchControlApiMethodOptions';
import { DynamicListControlItem } from './findDynamicListControlItems';
import { PrefetchResult } from '../types';
import { ResponseActionHandler } from '../../../../types/context';

export const fetchControlPrefetchResult = async (
  { name, controlItems, controlDefault }: DynamicListControlItem,
  requestData: RequestDataValue,
  getResponseActionHandler?: (name: string) => ResponseActionHandler | undefined
): Promise<PrefetchResult> => {
  try {
    const options = await fetchControlApiMethodOptions(
      controlItems,
      requestData,
      getResponseActionHandler
    );
    if (options.length === 0) return null;
    let defaultOpt = options[0];
    if (controlDefault !== undefined) {
      const match = options.find((o) => o.value === controlDefault);
      if (match) defaultOpt = match;
    }
    return { name, defaultValue: defaultOpt.value, options };
  } catch (error) {
    console.error(
      `Failed to prefetch list-control options for "${name}"`,
      error
    );
    return null;
  }
};
